module.exports = __webpack_public_path__ + "media/images/badges/yogasix-badge-bbe05512b7c7ffe4df7c43ac0758f727.png";